import { journeyAction, } from './base';

import { JourneyActionQueue as JourneyActionQueueBase, } from 'atlas-shared';

export const JourneyActionQueue = journeyAction({
  ...JourneyActionQueueBase,
  icon: 'Queue',
});
